export const C = Object.freeze({
  // Canvas
  CANVAS_W: 400,
  CANVAS_H: 700,

  // Paddle
  PADDLE_W: 70,
  PADDLE_H: 12,
  PADDLE_Y: 620,           // raised above thumb zone
  PADDLE_SPEED: 8.5,        // keyboard movement speed per tick
  PADDLE_COLOR: '#00ffff',
  SPIN_COEFFICIENT: 0.22,

  // Ball
  BALL_RADIUS: 5,
  BALL_SPEED: 3.8,         // initial speed (px per tick at 120Hz)
  BALL_MAX_SPEED: 7.5,
  BALL_COLOR: '#ffffff',
  BALL_TRAIL_LENGTH: 9,

  // Bricks
  BRICK_COLS: 10,
  BRICK_ROWS: 10,
  BRICK_W: 36,
  BRICK_H: 16,
  BRICK_GAP: 2,
  BRICK_OFFSET_X: 11,      // left margin to center grid: (400 - (10*36 + 9*2)) / 2 = 11
  BRICK_OFFSET_Y: 50,      // top margin below HUD

  // Brick types
  BRICK_STANDARD: 0,
  BRICK_HARDENED: 1,
  BRICK_ARMORED: 2,
  BRICK_TNT: 3,
  BRICK_VORTEX: 4,
  BRICK_PRISM: 5,
  BRICK_REGEN: 6,
  BRICK_INDESTRUCTIBLE: 7,
  BRICK_PHASE: 8,
  BRICK_EMPTY: -1,

  // Brick colors (array indexed by type)
  BRICK_COLORS: [
    '#00ffff',   // standard - cyan
    '#ffff00',   // hardened - yellow
    '#aaaaaa',   // armored - steel
    '#ff4400',   // TNT - orange-red
    '#aa00ff',   // vortex - purple
    '#ff00ff',   // prism - magenta rainbow
    '#00ff66',   // regen - green
    '#444444',   // indestructible - dark grey
    '#88bbff',   // phase - ghost blue
  ],

  // Brick HP by type
  BRICK_HP: [1, 2, 3, 1, 2, 1, 2, Infinity, 1],

  // Brick points by type
  BRICK_POINTS: [10, 25, 50, 30, 40, 20, 60, 0, 35],

  // Physics
  TICK_RATE: 1 / 120,

  // Particles
  MAX_PARTICLES: 200,
  PARTICLE_GRAVITY: 0.08,
  PARTICLE_FRICTION: 0.98,

  // Screen shake
  SHAKE_BRICK:   { intensity: 2, duration: 60 },
  SHAKE_ARMORED: { intensity: 3, duration: 80 },
  SHAKE_TNT:     { intensity: 6, duration: 150 },
  SHAKE_MISS:    { intensity: 8, duration: 200 },

  // HUD
  HUD_HEIGHT: 40,
  HUD_FONT: '14px monospace',
  HUD_COLOR: '#ffffff',

  // Power-up drop
  POWERUP_DROP_RATE: 0.15,
  POWERUP_FALL_SPEED: 1.5,
  POWERUP_W: 24,
  POWERUP_H: 12,

  // Colors
  BG_COLOR: '#0a0a0f',

  // Sector theme colors: [primary, secondary, accent]
  SECTOR_THEMES: [
    null, // index 0 unused
    { primary: '#00ffff', secondary: '#0044aa', accent: '#00ffff', gridAlpha: 0.04 },  // Sector 1: Neon Grid
    { primary: '#00cc88', secondary: '#003355', accent: '#00ffaa', gridAlpha: 0.035 },  // Sector 2: Cyber Depths
    { primary: '#ff6600', secondary: '#441100', accent: '#ff8800', gridAlpha: 0.03 },   // Sector 3: Solar Forge
    { primary: '#aa00ff', secondary: '#1a0033', accent: '#cc44ff', gridAlpha: 0.05 },   // Sector 4: Void Nexus
  ],

  // Borders
  BORDER_WIDTH: 3,
  BORDER_GLOW: 8,

  // Lives
  STARTING_LIVES: 3,

  // Combo
  COMBO_TIMEOUT: 2000,  // ms
  COMBO_MULTIPLIER_STEP: 0.25,
});
